"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var buttonTypeSchemaToSDK = {
    button: 'share-a',
    classicWithButton: 'share-e',
    classicBig: 'share-d',
    classicMedium: 'share-c',
    classicSmall: 'share-b',
    bubbleBig: 'share-h',
    bubbleMedium: 'share-g',
    bubbleSmall: 'share-f',
};
var LangugeSchemaToSDK = {
    en: 'en',
    ko: 'ko',
    ja: 'ja',
    zh: 'zh_Hant',
    th: 'th',
};
exports.props = withCompInfo_1.withCompInfo(['compProps', 'language'], function (_a) {
    var compProps = _a.compProps, language = _a.language;
    return {
        buttonType: buttonTypeSchemaToSDK[compProps.buttonType] || 'share-a',
        language: LangugeSchemaToSDK[language] || 'en',
    };
});
var buttonSizeByLanguage = {
    ko: { width: 63, height: 20 },
    ja: { width: 80, height: 20 },
    zh: { width: 46, height: 20 },
    th: { width: 47, height: 20 },
};
var sizeMapping = {
    classicWithButton: function () { return ({ width: 35, height: 60 }); },
    classicSmall: function () { return ({ width: 20, height: 20 }); },
    classicMedium: function () { return ({ width: 30, height: 30 }); },
    classicBig: function () { return ({ width: 40, height: 40 }); },
    bubbleSmall: function () { return ({ width: 20, height: 19 }); },
    bubbleMedium: function () { return ({ width: 30, height: 29 }); },
    bubbleBig: function () { return ({ width: 40, height: 40 }); },
    button: function (lang) { return buttonSizeByLanguage[lang] || { width: 53, height: 20 }; },
};
exports.css = withCompInfo_1.withCompInfo(['compProps', 'language'], function (_a) {
    var buttonType = _a.compProps.buttonType, language = _a.language;
    var _b = sizeMapping[buttonType](language), height = _b.height, width = _b.width;
    return { height: height + "px", width: width + "px" };
});
//# sourceMappingURL=LineShareButton.js.map